<template>
  <DatatableReport
    id="toDo_report"
    ref="toDos_datatable"
    no-download
    :source="source"
    :config="config"
    :map-records="applyFilter"
    :filters="filters"
  />
</template>

<script>
import { mapActions } from "vuex";
import { EventBus } from "@/lib/event_bus.js";

import DatatableCheckbox from "@/Reports/DatatableCheckbox.vue";
import DatatableReport from "@/Reports/DatatableReportV3.vue";
import ItemSummary from "./ItemSummary.vue";

export default {
  components: {
    DatatableReport
  },
  props: {
    source: {
      type: String,
      default: ""
    },
    filters: {
      type: Array,
      default: () => []
    },
    recordFilter: {
      type: String,
      default: ""
    }
  },
  data() {
    return {
      config: {
        responsive: true,
        order: [[4, "asc"]],
        columns: [
          {
            data: "created_at",
            responsivePriority: 5,
            title: "Date Created",
            className: "date-column"
          },
          { data: "assigned_to", responsivePriority: 4, title: "Assigned to" },
          { data: "created_by", responsivePriority: 6, title: "Created by" },
          {
            data: "summary",
            responsivePriority: 1,
            title: "To-Do",
            className: "todo-column wrap-when-responsive",
            orderable: false
          },
          {
            data: "due_by",
            responsivePriority: 3,
            title: "Due by",
            className: "date-column"
          },
          {
            data: "completed",
            responsivePriority: 2,
            title: "Done",
            orderable: false,
            className: "text-center"
          }
        ],
        vueComponents: [
          {
            rootId: "datatable-checkbox-vue",
            component: DatatableCheckbox
          },
          {
            rootId: "item-summary-vue",
            component: ItemSummary
          }
        ]
      }
    };
  },
  mounted() {
    EventBus.$on("datatable-checkbox-change", this.handleCheck);
    EventBus.$on("refresh-todos-table", this.refreshData);
  },
  beforeUnmount() {
    EventBus.$off("datatable-checkbox-change", this.handleCheck);
    EventBus.$off("refresh-todos-table", this.refreshData);
  },
  methods: {
    ...mapActions(["setToDoCompleted", "fetchTodo", "fetchIncompleteTodos"]),
    handleCheck({ value }) {
      this.setToDoCompleted(value).then(() => this.refreshData());
    },
    refreshData() {
      EventBus.$emit("refresh-datatable");
    },
    applyFilter(record) {
      const adminId = window.currentTenant.user_id;
      if (this.recordFilter === "assigned_to") {
        return {
          ...record,
          owner_id: adminId
        };
      }
      if (this.recordFilter === "created_by") {
        return {
          ...record,
          author_id: adminId
        };
      }
      return record;
    }
  }
};
</script>

<style lang="scss"></style>
